import { Modal } from 'react-bootstrap'
import useGetUsers from './hooks/useGetUsers'
import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'
import { useEffect, useState } from 'react'
import { CiSearch } from 'react-icons/ci'
import InfiniteScroll from 'react-infinite-scroll-component'
interface ISelectUser {
    name: string
    id: undefined | number
    memberId: undefined | number
}
interface IModalProps {
    show: boolean
    onHide: () => void
    setSelectedUser: React.Dispatch<
        React.SetStateAction<ISelectUser | undefined>
    >
    setMemberId: React.Dispatch<React.SetStateAction<number | undefined>>
    title?: string
    /**
     * Pick on the tap itself: tapping a name selects it and closes the modal,
     * with no «تایید» step.
     *
     * The two-step version (tap a name, then find «تایید» under the list) is
     * where the add-member screen lost its managers: a tap only moved a small
     * tick, and closing the modal any other way — the backdrop, back — threw
     * the choice away without a word, so «ضامن» still read «اختیاری» and it
     * looked as though nothing had happened.
     */
    selectOnTap?: boolean
}
export default function SelectModal({
    show,
    onHide,
    setSelectedUser,
    setMemberId,
    title,
    selectOnTap = false,
}: IModalProps) {
    const [select, setSelect] = useState<ISelectUser>()
    const [searchTransaction, setSearchtransaction] = useState<string>(' ')
    const [searchTrans, setSearchTrans] = useState<string>(' ')
    const { data, isLoading, handleSelect, fetchNextPage, hasNextPage } =
        useGetUsers(setSelect, searchTransaction)

    const pickAndClose: React.Dispatch<
        React.SetStateAction<ISelectUser | undefined>
    > = (user) => {
        setSelect(user)
        setSelectedUser(user)
        onHide()
    }

    useEffect(() => {
        if (searchTrans === '') {
            setSearchtransaction('')
        }
    }, [searchTrans])

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" py-3 px-2">
                <p className=" text-center text-sm">
                    {title ? title : 'دریافت کننده را انتخاب کنید'}
                </p>
                {selectOnTap && (
                    <p className=" text-center text-xs text-gray-1 mt-1">
                        روی نام عضو بزنید
                    </p>
                )}
                <hr className=" my-2" />
                {/* the row used to be pinned to h-[25px] while the input's own
                    padding made it taller, so it spilled over the first member
                    and clipped the magnifier */}
                <div className="flex items-center mb-1">
                    <input
                        type="text"
                        className=" w-full outline-0 border border-green-1 rounded-full px-2 py-1 ml-3"
                        onChange={(e) => setSearchTrans(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault()
                                setSearchtransaction(searchTrans)
                            }
                        }}
                        value={searchTrans}
                        placeholder="جستجو..."
                    />
                    <CiSearch
                        className=" text-green-1 w-8 shrink-0 cursor-pointer"
                        size={22}
                        onClick={() => {
                            setSearchtransaction(searchTrans)
                        }}
                    />
                </div>
                <div
                    id="select-modal-members"
                    className=" h-72 overflow-y-auto"
                >
                    {isLoading ? (
                        <DotsLoading />
                    ) : (
                        <InfiniteScroll
                            next={fetchNextPage}
                            hasMore={Boolean(hasNextPage)}
                            dataLength={data ? data.length : 0}
                            loader={<DotsLoading />}
                            scrollableTarget="select-modal-members"
                        >
                            {data && data.length === 0 && (
                                <p className=" text-center text-sm text-gray-1 py-6">
                                    عضوی پیدا نشد
                                </p>
                            )}
                            {data &&
                                data.map((item, index) => {
                                    if (item.is_active) {
                                        return (
                                            <Item
                                                key={item.id}
                                                item={item}
                                                index={index}
                                                handleSelect={handleSelect}
                                                setSelectedUser={
                                                    selectOnTap
                                                        ? pickAndClose
                                                        : setSelect
                                                }
                                                setMemberId={setMemberId}
                                            />
                                        )
                                    }
                                    return null
                                })}
                        </InfiniteScroll>
                    )}
                </div>
                <div>
                    <hr className=" my-2" />
                    <p
                        className=" text-green-1 text-center cursor-pointer"
                        onClick={() => {
                            onHide()
                            if (selectOnTap) {
                                return
                            }
                            // Confirming without touching a row must not clear
                            // whatever the caller had already selected — the
                            // deposit flow pre-selects the payer, and wiping it
                            // sent the request with `poolship: undefined`.
                            if (select) {
                                setSelectedUser(select)
                            }
                        }}
                    >
                        {selectOnTap ? 'بستن' : 'تایید'}
                    </p>
                </div>
            </div>
        </Modal>
    )
}
